import {
  FETCH_ALIASES_FOR_ASSET_REQUEST, FETCHING_ALIASES_FOR_ASSET_SUCCEDDED, FETCHING_ALIASES_FOR_ASSET_FAILED, 
  UPDATE_ALIASES_FOR_ASSET, UPDATING_ALIASES_FOR_ASSET_SUCCEEDED, UPDATING_ALIASES_FOR_ASSET_FAILED, 
  CREATE_ALIASES_FOR_ASSET, CREATING_ALIASES_FOR_ASSET_SUCCEEDED, CREATING_ALIASES_FOR_ASSET_FAILED, INVALIDATE_CREATE_ALIASES_FOR_ASSET, DELETE_ALIASES_FOR_ASSET, DELETING_ALIASES_FOR_ASSET_SUCCEEDED, DELETING_ALIASES_FOR_ASSET_FAILED, INVALIDATE_ALIASES_FOR_ASSET
} from 'constants/actionTypes';

import _ from 'lodash';
import buildUrl from 'build-url';
import { createAction } from 'redux-actions';
import { call, put, takeEvery, select } from 'redux-saga/effects';
import axios from 'axios';
import { updateAliasinLayoutContent } from './layoutManager';

const cleverstoryApiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const ALIAS_URL = `${cleverstoryApiUrl}/api/2.0/aliases`

export const fetchAliasesForAsset = createAction(FETCH_ALIASES_FOR_ASSET_REQUEST, (filterRequest, page, limit) => {
  return {
    filterRequest, page, limit,
  };
});

const fetchingAliasesForAssetSuccedded = createAction(FETCHING_ALIASES_FOR_ASSET_SUCCEDDED, (filterRequest, response) => {
  return {
    filterRequest, response
  };
});

const fetchingAliasesForAssetFailed = createAction(FETCHING_ALIASES_FOR_ASSET_FAILED, (filterRequest, error) => {
  return {
    filterRequest,
    error,
  };
});

function* fetchAliasesForAssetSaga(action){
  const { filterRequest, page, limit } = action.payload;

  const params = {
    page,
    limit,
  };


  let url = buildUrl(ALIAS_URL, {
    path: '/all',
    queryParams: params
  });

  const fetchAliasesForAssetAPI = () => {
    return axios.post(url, filterRequest).then(response => response.data);
  }

  try {
    const response = yield call(fetchAliasesForAssetAPI);
    if (response) {
      yield put(fetchingAliasesForAssetSuccedded(filterRequest, response));
    }
  } catch (error) {
    console.log(error);
    yield put(fetchingAliasesForAssetFailed(filterRequest, error));
  }
}

export const invalidateAliasForAsset = createAction(INVALIDATE_ALIASES_FOR_ASSET);

/*
  Create Alias for asset
*/
export const createAliasForAsset = createAction(CREATE_ALIASES_FOR_ASSET, (request) => {
  return {
    request,
  };
});

export const creatingAliasForAssetSucceeded = createAction(CREATING_ALIASES_FOR_ASSET_SUCCEEDED, (response) => {
  return {
    response,
  };
});


export const creatingAliasForAssetFailed = createAction(CREATING_ALIASES_FOR_ASSET_FAILED, (error) => {
  return {
    error,
  };
});

function* createAliasForAssetSaga(action){
  const { request } = action.payload;

  const createAliasesForAssetAPI = () => {
    return axios.post(ALIAS_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(createAliasesForAssetAPI);
    if (response) {
      yield put(creatingAliasForAssetSucceeded(response));
    }
  } catch (error) {
    console.log(error);
    yield put(creatingAliasForAssetFailed(error));
  }
}

export const invalidateCreateAliasForAsset = createAction(INVALIDATE_CREATE_ALIASES_FOR_ASSET);

/*
  Update Alias for asset
*/
export const updateAliasForAsset = createAction(UPDATE_ALIASES_FOR_ASSET, (id, request, prevAlias) => {
  return {
    id, request, prevAlias
  };
});

export const updatingAliasForAssetSucceeded = createAction(UPDATING_ALIASES_FOR_ASSET_SUCCEEDED, (id, response, prevAlias) => {
  return {
    id, response, prevAlias
  };
});


export const updatingAliasForAssetFailed = createAction(UPDATING_ALIASES_FOR_ASSET_FAILED, (id, error) => {
  return {
    id, error,
  };
});

function* updateAliasForAssetSaga(action){
  const { id, request, prevAlias } = action.payload;

  let url = buildUrl(ALIAS_URL, {
    path: `/${id}`
  });

  const updateAliasesForAssetAPI = () => {
    return axios.put(url, request).then(response => response.data);
  }

  try {
    const response = yield call(updateAliasesForAssetAPI);
    if (response) {
      yield put(updatingAliasForAssetSucceeded(id, response, prevAlias));
    }
  } catch (error) {
    console.log(error);
    yield put(updatingAliasForAssetFailed(id, error));
  }
}

/*
  Delete Alias for asset
*/
export const deleteAliasForAsset = createAction(DELETE_ALIASES_FOR_ASSET, (id, onDeleteRequest) => {
  return {
    id, onDeleteRequest
  };
});

export const deletingAliasForAssetSucceeded = createAction(DELETING_ALIASES_FOR_ASSET_SUCCEEDED, (id, response) => {
  return {
    id, response,
  };
});


export const deletingAliasForAssetFailed = createAction(DELETING_ALIASES_FOR_ASSET_FAILED, (id, error) => {
  return {
    id, error,
  };
});

function* deleteAliasForAssetSaga(action){
  const { id, onDeleteRequest } = action.payload;

  let url = buildUrl(ALIAS_URL, {
    path: `/${id}`
  });

  const deleteAliasesForAssetAPI = () => {
    return axios.delete(url).then(response => response.data);
  }

  try {
    yield call(deleteAliasesForAssetAPI);
    yield put(deletingAliasForAssetSucceeded(id));

    if(onDeleteRequest.aliasUsedInLayout){
      const { editorSession, contentId, canonicalUrl } = onDeleteRequest;
      yield put(updateAliasinLayoutContent(editorSession, contentId, canonicalUrl));
    }
  } catch (error) {
    console.log(error);
    yield put(deletingAliasForAssetFailed(id, error));
  }
}

export default function* assetAliasesSaga() {
  yield takeEvery(FETCH_ALIASES_FOR_ASSET_REQUEST, fetchAliasesForAssetSaga);
  yield takeEvery(CREATE_ALIASES_FOR_ASSET, createAliasForAssetSaga);
  yield takeEvery(UPDATE_ALIASES_FOR_ASSET, updateAliasForAssetSaga);
  yield takeEvery(DELETE_ALIASES_FOR_ASSET, deleteAliasForAssetSaga);
};